module.exports = __webpack_public_path__ + "img/LOGO-3.e2d5fc31.png";